<script>
export default {
  name: "SetUp",
  data() {
    return {
      loadingBranches: false,
      branches: [],
      selectedBranch: null,
      branchRules: [
        v => !!v || 'Branch selection is required'
      ],
    }
  },
  beforeMount() {
    this.fetchBranches();
  },
  methods: {
    async fetchBranches() {
      this.loadingBranches = true;
      try {
        const userId = this.$store.getters.CurrentUserInfo.id;
        const data = await this.$store.dispatch("fetchBranches", userId);
        this.branches = data;
      } catch (error) {
        console.error('Error fetching branches:', error);
      } finally {
        this.loadingBranches = false;
      }
    },

    async onBranchSelect() {
      if (!this.selectedBranch) {
        this.showError("Please select a branch before continuing.");
        return;
      }

      if (this.selectedBranch.store_id) {
        await this.$store.dispatch("subscription/checkSubscription", this.selectedBranch.store_id);
        const subscription = this.$store.getters["subscription/getSubscription"];
        if (subscription && new Date(subscription.Expire) < new Date()) {
          this.showError("Your subscription has expired. Please renew your subscription through the Lytning platform.");
        } else {
          this.$store.commit('setBranch', this.selectedBranch);
          this.$router.push('/payments/create-link');
        }
      } else {
        this.$store.commit('setBranch', this.selectedBranch);
        this.$router.push('/payments/create-link');
      }
    },
    showError(message) {
      // You can use a library like sweetalert2 or a custom component to show the error
      alert(message);
    }
  }
}
</script>

<template>
  <v-container class="fill-height clean-container" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="clean-card elevation-3" rounded="lg">
          <v-card-text class="pa-8">
            <!-- Header -->
            <div class="text-center mb-8">
              <h1 class="card-title mb-3 text-dark" style="font-weight:700"><span
                style="color: rgb(var(--v-theme-primary))">cash.co.zm</span> Branch Selection</h1>
            </div>

            <v-form>
              <div class="mb-6">
                <label class="field-label text--primary font-weight-medium mb-2 d-block">
                  Branch
                </label>
                <v-select
                  v-model="selectedBranch"
                  :items="branches"
                  item-title="branchName"
                  return-object
                  :rules="branchRules"
                  placeholder="Select your branch"
                  prepend-inner-icon="mdi-store"
                  outlined
                  dense
                  hide-details="auto"
                  class="clean-input"
                  color="primary"
                  :loading="loadingBranches"
                  :disabled="loadingBranches"
                  required
                >
                  <template v-slot:no-data>
                    <div class="pa-2">No branches available</div>
                  </template>
                </v-select>
              </div>

              <!-- Continue Button -->
              <v-btn
                color="primary"
                :disabled="!selectedBranch || loadingBranches"
                :loading="loadingBranches"
                large
                block
                depressed
                class="login-button text-capitalize font-weight-medium mt-6"
                @click="onBranchSelect"
              >
                Continue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.clean-container {
  background-color: rgb(var(--v-theme-background));
  min-height: 100vh;
}

.clean-card {
  background: rgb(var(--v-theme-surface));
  max-width: 400px;
  margin: 0 auto;
}

.card-title {
  color: rgb(var(--v-theme-text-primary));
}

.brand-span {
  color: rgb(var(--v-theme-primary));
}

.field-label {
  font-size: 16px;
  color: rgb(var(--v-theme-text-primary));
}

.clean-input :deep(.v-input__control) {
  min-height: 50px !important;
}

.clean-input :deep(.v-text-field__details) {
  margin-top: 4px;
}

.clean-input :deep(.v-input__prepend-inner) {
  margin-top: 14px;
  margin-right: 12px;
}

.clean-input :deep(.v-text-field--outlined fieldset) {
  border-color: rgb(var(--v-theme-border-color));
  border-width: 1px;
}

.clean-input :deep(.v-text-field--outlined:hover fieldset) {
  border-color: rgba(var(--v-theme-on-surface), 0.5);
}

.clean-input :deep(.v-text-field--outlined.v-input--is-focused fieldset) {
  border-color: rgb(var(--v-theme-primary)) !important;
  border-width: 2px !important;
}

.clean-input :deep(.v-text-field__slot input) {
  font-size: 15px;
  color: rgb(var(--v-theme-text-secondary));
}

.clean-input :deep(.v-text-field__slot input::placeholder) {
  color: rgb(var(--v-theme-text-secondary)) !important;
  opacity: 0.7;
}

.login-button {
  height: 48px !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}

.login-button:hover {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.3) !important;
}

/* Responsive */
@media (max-width: 600px) {
  .clean-card {
    margin: 16px;
  }

  .pa-8 {
    padding: 32px 24px !important;
  }
}
</style>
